var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortDescend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.178 21.821L17.928 15.071C18.1189 14.8802 18.2143 14.6542 18.2143 14.393C18.2143 14.1318 18.1189 13.9058 17.928 13.715C17.7372 13.5241 17.5112 13.4287 17.25 13.4287H1.75C1.48884 13.4287 1.26283 13.5241 1.07199 13.715C0.881137 13.9058 0.785713 14.1318 0.785713 14.393C0.785713 14.6542 0.881137 14.8802 1.07199 15.071L8.82199 21.821C9.01283 22.0119 9.23884 22.1073 9.5 22.1073C9.76116 22.1073 9.98716 22.0119 10.178 21.821ZM4.52783 15.4287L9.5 19.7593L14.4722 15.4287H4.52783Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDescend);
export default __webpack_public_path__ + "static/media/sort-descend.d4f3a79d11f4c8ce93bb8bd814530507.svg";
export { ForwardRef as ReactComponent };